module.exports = __webpack_public_path__ + "media/images/arrow_collapse-4ca361416bb0850eccc3ec6b3c7d7966.svg";